export default "__VITE_ASSET__BlVjXRa3__"